import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { APP_CONSTANT } from 'src/app/core/_constants/app.constant';
import { RouteConstant } from 'src/app/core/_constants/route.constant';
import { LocalStorageProvider } from 'src/app/core/_services/common/storage.service';
import { AuthService } from 'src/app/core/_services/pages/auth.service';
import { PagesService } from 'src/app/core/_services/pages/pages.service';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent implements OnInit {
  show=false;
  message = {
    heading: '',
    subHeading: '',
    image: '',
    button: '',
    link: ''
  }
  successMessage = APP_CONSTANT.VERIFYEMAIL.success;
  failedMessage = APP_CONSTANT.VERIFYEMAIL.failed;
  sessionExpired = APP_CONSTANT.VERIFYEMAIL.session;
  constructor(private router: Router,private activatedRoute: ActivatedRoute,private service: PagesService,private loader: NgxUiLoaderService,private toastr: ToastrService,private storageService: LocalStorageProvider, private authService: AuthService) { }

  ngOnInit(): void {
    // if(this.storageService.getItem("Email")){
    this.activatedRoute.paramMap.subscribe(params => {
      this.loader.start();
      this.getEncryptString(params);
    });
    // }else {
    //  this.setFailedMessage();
    // }
  }

  
  loginPage() {
    this.router.navigate([`${RouteConstant.Login}`])
  }

  setFailedMessage(){
    this.message = {
      heading: this.failedMessage.heading,
      subHeading: this.failedMessage.subHeading,
      image: this.failedMessage.image,
      button: this.failedMessage.button,
      link: `${'../../'+RouteConstant.Login}`,
    }
    this.show = true;
  }
  setSuccessMessage(){
    this.message = {
      heading: this.successMessage.heading,
      subHeading: this.successMessage.subHeading,
      image: this.successMessage.image,
      button: this.successMessage.button,
      link: `${'../../'+RouteConstant.ResetPassword}`,
    }
    this.show = true;
  }

  setSessionExpiredMessage(){
    this.message = {
      heading: this.sessionExpired.heading,
      subHeading: this.sessionExpired.subHeading,
      image: this.sessionExpired.image,
      button: this.sessionExpired.button,
      link: `${'../../'+RouteConstant.Login}`,
    }
    this.show = true;
  }
  getEncryptString(params:any){
    if (params.get('encryptStr')) {
      const encryptStr = params.get('encryptStr');
       this.verifyMail(encryptStr);
    }
  }

  verifyMail(encryptStr: any){
    const data = {
      str:encryptStr
    }
    this.service.get(data,`${API_ROUTES.ACCOUNT.verifyEmail}`).pipe().subscribe(response => {
      console.log(response)
      if(response.status){
        this.authService.adminEmail= response.data.email;
        this.setSuccessMessage();
      }else {
        if(response.msg == 'Verification Link Expire'){
          this.setSessionExpiredMessage()
        }else {
          this.setFailedMessage();
        }
      }
      this.loader.stop();
    })
  }

}
